import React, { useState, useEffect } from 'react';
import './App.css';

// ▼▼ 1. データの準備（ここからランダムに選ばれます） ▼▼
const fortuneTexts = [
  { stars: "★★★★★", content: "絶好調！何をしてもうまくいく最強の日。自信を持ってアタックして。" },
  { stars: "★★★★★", content: "愛の星が味方しています。運命的な出会いや再会の予感。" },
  { stars: "★★★★☆", content: "あなたの魅力が周囲に伝わりやすい日。笑顔を絶やさないで。" },
  { stars: "★★★★☆", content: "コミュニケーション運が好調。気になる人を食事に誘うチャンス！" },
  { stars: "★★★★☆", content: "穏やかな幸せを感じられる日。パートナーへの感謝を言葉にして。" },
  { stars: "★★★☆☆", content: "安定した運気です。焦らずマイペースに過ごすのが吉。" },
  { stars: "★★★☆☆", content: "ちょっとした誤解が生まれやすいかも。言葉選びは慎重に。" },
  { stars: "★★★☆☆", content: "今日は自分磨きに適した日。ゆっくりお風呂に入ってリラックス。" },
  { stars: "★★☆☆☆", content: "感情の波が激しくなりそう。深呼吸して冷静さを取り戻して。" },
  { stars: "★★☆☆☆", content: "相手に求めすぎないことが大切。今日は聞き役に回るとスムーズ。" },
];

const adviceTexts = [
  "「ありがとう」の一言を忘れずに。",
  "新しい色のリップやネクタイが幸運の鍵。",
  "無理に合わせず、自分の時間も大切にして。",
  "懐かしい音楽を聴くと恋愛運アップ。",
  "目を見て話すことで、想いが伝わります。",
  "SNSのチェックはほどほどに。リアルな会話を楽しんで。",
  "いつもより少し早起きすると良いことがありそう。",
  "甘いスイーツを食べてエネルギーチャージ。",
];

const luckyItems = [
  "スニーカー", "腕時計", "アロマキャンドル", "マグカップ",
  "手帳", "香水", "帽子", "観葉植物", "本", "ハンカチ"
];

const luckyColors = [
  "レッド", "ブルー", "イエロー", "ピンク", "ホワイト",
  "ブラック", "ゴールド", "シルバー", "グリーン", "パープル", "オレンジ"
];

const zodiacSigns = [
  { name: "牡羊座", symbol: "♈", range: "3/21〜4/19" },
  { name: "牡牛座", symbol: "♉", range: "4/20〜5/20" },
  { name: "双子座", symbol: "♊", range: "5/21〜6/21" },
  { name: "蟹座", symbol: "♋", range: "6/22〜7/22" },
  { name: "獅子座", symbol: "♌", range: "7/23〜8/22" },
  { name: "乙女座", symbol: "♍", range: "8/23〜9/22" },
  { name: "天秤座", symbol: "♎", range: "9/23〜10/23" },
  { name: "蠍座", symbol: "♏", range: "10/24〜11/22" },
  { name: "射手座", symbol: "♐", range: "11/23〜12/21" },
  { name: "山羊座", symbol: "♑", range: "12/22〜1/19" },
  { name: "水瓶座", symbol: "♒", range: "1/20〜2/18" },
  { name: "魚座", symbol: "♓", range: "2/19〜3/20" },
];

function App() {
  const [selectedFortune, setSelectedFortune] = useState(null);
  const [todayDate, setTodayDate] = useState(new Date());

  // 日付が変わったかどうかをチェックする機能（アプリを開いたまま0時を過ぎた場合に対応）
  useEffect(() => {
    const timer = setInterval(() => {
      setTodayDate(new Date());
    }, 60000); // 1分ごとに日付を再取得
    return () => clearInterval(timer);
  }, []);

  // 日付表示用
  const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
  const daySymbol = daysOfWeek[todayDate.getDay()];
  const dateString = `${todayDate.getFullYear()}年${todayDate.getMonth() + 1}月${todayDate.getDate()}日（${daySymbol}）`;

  // ▼▼ 2. 運勢を生成するロジック（日付が変わると結果が変わる魔法の計算） ▼▼
  const generateDailyFortune = (sign) => {
    // 今日の日付を数値化（例：20251121）
    const dateNum = todayDate.getFullYear() * 10000 + (todayDate.getMonth() + 1) * 100 + todayDate.getDate();
    
    // 星座の名前を数値コードに変換
    let signNum = 0;
    for (let i = 0; i < sign.name.length; i++) {
      signNum += sign.name.charCodeAt(i);
    }

    // 擬似乱数生成（日付 + 星座ごとの固有番号 を使って、その日固定の「あたり」を決める）
    // ※この計算式により、同じ日なら何度押しても同じ結果になり、日が変わると変わります。
    const seed = dateNum + signNum;

    const fortuneIndex = seed % fortuneTexts.length;
    const adviceIndex = (seed * 2) % adviceTexts.length;
    const itemIndex = (seed * 3) % luckyItems.length;
    const colorIndex = (seed * 4) % luckyColors.length;

    return {
      name: sign.name,
      symbol: sign.symbol,
      range: sign.range,
      stars: fortuneTexts[fortuneIndex].stars,
      content: fortuneTexts[fortuneIndex].content,
      advice: adviceTexts[adviceIndex],
      luckyItem: luckyItems[itemIndex],
      luckyColor: luckyColors[colorIndex],
    };
  };

  const handleSignClick = (sign) => {
    const dailyFortune = generateDailyFortune(sign);
    setSelectedFortune(dailyFortune);
  };

  return (
    <div className="app-container">
      <div className="card">
        <h1 className="title">12星座 恋愛運鑑定</h1>
        <p className="today-date">{dateString}</p>
        <p className="subtitle">あなたの星座を選んで今日の恋愛運をチェック！</p>

        <div className="grid-container">
          {zodiacSigns.map((sign) => (
            <button
              key={sign.name}
              className="zodiac-btn"
              onClick={() => handleSignClick(sign)}
            >
              <span className="symbol">{sign.symbol}</span> {sign.name}
            </button>
          ))}
        </div>

        <div className="result-box">
          {!selectedFortune ? (
            <p className="placeholder-text">星座をクリックして占いを表示！</p>
          ) : (
            <div className="fortune-content">
              <h2 className="fortune-title">
                {selectedFortune.symbol} {selectedFortune.name}
                <span className="fortune-range">（{selectedFortune.range}）</span>
              </h2>
              
              <div className="fortune-stars">
                恋愛運：<span className="stars-color">{selectedFortune.stars}</span>
              </div>
              
              <p className="fortune-text">{selectedFortune.content}</p>
              
              <div className="fortune-advice">
                <span className="advice-label">アドバイス：</span>
                {selectedFortune.advice}
              </div>

              <div className="lucky-container">
                <div className="lucky-box">
                  <span className="lucky-icon">🎁</span>
                  <span className="lucky-label">ラッキーアイテム</span>
                  <span className="lucky-value">{selectedFortune.luckyItem}</span>
                </div>
                <div className="lucky-box">
                  <span className="lucky-icon">🎨</span>
                  <span className="lucky-label">ラッキーカラー</span>
                  <span className="lucky-value">{selectedFortune.luckyColor}</span>
                </div>
              </div>

            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;